import { createEntityAdapter } from "@ngrx/entity";
import { createFeature, createReducer, createSelector, on } from "@ngrx/store";
import { StoreStatus } from "@utility/state";
import { Remitter } from "../models/remitter.model";
import { loadRemitters, loadRemittersFailure, loadRemittersSuccess } from "./remitter.actions";
import { RemitterState } from "./remitter.state";

export const remitterAdapter = createEntityAdapter<Remitter>();

const initialState: RemitterState = remitterAdapter.getInitialState({
	status: StoreStatus.PENDING,
	error: undefined
});

export const remitterFeature = createFeature({
	name: "remitters",
	reducer: createReducer(
		initialState,
		on(loadRemitters, (state) => ({
			...state,
			status: StoreStatus.INITIALISING
		})),
		on(loadRemittersSuccess, (state, { remitters }) => {
			return remitterAdapter.setAll(remitters, {
				...state,
				status: StoreStatus.SUCCESS,
				error: undefined
			});
		}),
		on(loadRemittersFailure, (state, error) => ({
			...state,
			error: error.error,
			status: StoreStatus.ERROR
		}))
	),
	extraSelectors: ({ selectRemittersState }) => ({
		selectRemitters: createSelector(selectRemittersState, (state: RemitterState | undefined) =>
			remitterAdapter.getSelectors().selectAll(state ?? remitterAdapter.getInitialState())
		)
	})
});

export const { name, reducer, selectRemittersState, selectRemitters } = remitterFeature;
